import { PrizeTypes } from "../brandVariables.types";

export const jblPrize: PrizeTypes = {
  content: "Win a ",
  nameOf: "JBL QUANTUM 910 ", // will be marked in color
  typeOfItem: "WIRELESS HEADSET", // will be added after nameOf

  emptyPrize: "/static/images/tenants/jbl/jbl_quantum910.png",
};
